import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "value", "disabled", "min", "step"]

import { computed, ref } from "vue";


const __default__ = {
    compatConfig: {
        MODE: "compatible",
    },
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'currency-formatted-input',
  props: {
    modelValue: Number,
    disabled: Boolean,
    min: Number,
    step: Number,
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const inFocus = ref(false);

const inputElement = ref<HTMLInputElement>();

function setFocus(v: boolean) {
    if (inFocus.value === v) {
        return;
    }
    if (v) {
        inFocus.value = true;

        // nextTick(() => {
        //     if (!numberInput.value)
        //         throw new Error("numberInput is not defined");
        //     numberInput.value.focus();
        //     if (selectionStart != null && selectionEnd != null) {
        //         numberInput.value.setSelectionRange(
        //             selectionStart,
        //             selectionEnd
        //         );
        //     }
        // });
    } else {
        inFocus.value = false;
    }
}

const emit = __emit;

const formattedValue = computed(() => {
    if (props.modelValue != null)
        return new Intl.NumberFormat("da-DK").format(props.modelValue);
    return undefined;
});

const onInput = (event: Event) => {
    const eventTarget = event.target as HTMLInputElement;
    if (eventTarget.type === "text") {
        event.preventDefault();
        setFocus(true);
        return;
    }
    const value = eventTarget.valueAsNumber;
    if (isNaN(value)) {
        emit("update:modelValue", undefined);
    } else {
        emit("update:modelValue", value);
    }
};

// watch(
//     () => props.modelValue,
//     (newValue) => {
//         if (newValue == null || isNaN(newValue)) {
//             emit("update:modelValue", undefined);
//         }
//     }
// );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: inFocus.value ? 'number' : 'text',
    ref_key: "inputElement",
    ref: inputElement,
    value: inFocus.value ? __props.modelValue : formattedValue.value,
    onInput: onInput,
    inputmode: "numeric",
    disabled: __props.disabled,
    min: __props.min,
    step: __props.step,
    onBlur: _cache[0] || (_cache[0] = ($event: any) => (setFocus(false))),
    onFocus: _cache[1] || (_cache[1] = ($event: any) => (setFocus(true)))
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})